import { useEffect, useState } from "react";
import QuoteFunnel from "./QuoteFunnel";
import BillUploadFlow from "./BillUploadFlow";

type Mode = "postcode" | "bill";

export default function PostcodeOrBillFork() {
  const [mode, setMode] = useState<Mode>("postcode");
  const [focusToken, setFocusToken] = useState(0);

  useEffect(() => {
    const focusPostcode = () => {
      setMode("postcode");
      setFocusToken((token) => token + 1);
    };
    window.addEventListener("powlo-focus-postcode", focusPostcode);
    return () => window.removeEventListener("powlo-focus-postcode", focusPostcode);
  }, []);

  return (
    <div className="flex w-full flex-col items-center gap-4">
      <div className="flex w-full max-w-2xl gap-2 rounded-full bg-[#F1F0EC] p-1.5" role="tablist" aria-label="How to get your plan">
        <TabButton active={mode === "postcode"} onClick={() => setMode("postcode")}>
          <PinIcon active={mode === "postcode"} />
          <span className="min-w-0">Address Lookup</span>
        </TabButton>
        <TabButton active={mode === "bill"} onClick={() => setMode("bill")}>
          <UploadIcon active={mode === "bill"} />
          <span className="min-w-0">Upload Energy Bill</span>
        </TabButton>
      </div>

      {mode === "postcode" ? <QuoteFunnel focusToken={focusToken} /> : <BillUploadFlow />}
    </div>
  );
}

function TabButton({
  active,
  onClick,
  children,
}: {
  active: boolean;
  onClick: () => void;
  children: React.ReactNode;
}) {
  return (
    <button
      type="button"
      role="tab"
      aria-selected={active}
      onClick={onClick}
      className={`flex min-h-[48px] min-w-0 flex-1 items-center justify-center gap-2 rounded-full px-3 text-center text-[13px] font-bold leading-tight transition-colors sm:text-base ${
        active ? "bg-navy text-white" : "bg-transparent text-ink"
      }`}
    >
      {children}
    </button>
  );
}

function PinIcon({ active }: { active: boolean }) {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 24 24"
      fill="none"
      stroke={active ? "#FFFFFF" : "#0C0D10"}
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      className="shrink-0"
    >
      <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
      <circle cx="12" cy="10" r="2.6" />
    </svg>
  );
}

function UploadIcon({ active }: { active: boolean }) {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 24 24"
      fill="none"
      stroke={active ? "#FFFFFF" : "#0C0D10"}
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      className="shrink-0"
    >
      <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8Z" />
      <path d="M14 3v5h5M12 17v-6M9.5 13.5 12 11l2.5 2.5" />
    </svg>
  );
}
